import { apiFetch } from './api'

// Module executes before router creation; no token ever enters router history
// state, web storage, network query strings or application logs.
let incomingToken = ''
if (['/account/verify-email', '/account/reset-password'].includes(window.location.pathname)) {
  incomingToken = new URLSearchParams(window.location.hash.slice(1)).get('token') || ''
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search)
}
export function takeEmailToken() { const token = incomingToken; incomingToken = ''; return token }

const messages = {
  wrong_account: 'Sign in to the account this email belongs to.',
  invalid_or_expired_link: 'This link is invalid, expired, or already used. Request a new one.',
  email_unavailable_contact_teacher: 'Email recovery is unavailable. Please contact your teacher or administrator.',
  binding_not_allowed: 'Self-service email binding is disabled for this account. Contact your teacher or administrator.',
  password_and_reason_required: 'Enter your correct administrator password and a reason for this change.',
  try_again_later: 'Too many attempts. Please try again later or ask your teacher for help.',
  password_requirements: 'Use at least 12 characters, not a common or all-number password.',
  password_change_required: 'Change your temporary password first, then sign in again and request a new verification email from Profile. This link will no longer work after the password change.',
  passwords_do_not_match: 'The passwords do not match.',
  please_wait_before_resending: 'Please wait at least 60 seconds before sending again. The hourly limit is five messages.',
  incorrect_password: 'Your current password is incorrect.',
  authentication_required: 'Please sign in again.',
  email_unavailable: 'This email cannot be used. Contact your administrator.',
  invalid_email: 'Enter a valid email address.',
  preview_changed: 'The preview is out of date. Preview the file again.',
}
export async function accountRequest(path, data) {
  const response = await apiFetch(path, data === undefined ? {} : { method: 'POST', body: JSON.stringify(data) })
  const result = await response.json()
  if (!response.ok) {
    const error = new Error(messages[result.code] || result.error || 'The request failed. Please try again.')
    error.code = result.code
    throw error
  }
  return result
}
